import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import authAxios from "../../../../config/authAxios"




const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getSingleBankDetailsAction = createAsyncThunk(
    'get-single-bank',
    async (data, { rejectWithValue }) => {
        try {
            const res = await authAxios.patch(`/support-server/api/single-publisher-bank-details`,data)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getSingleBankDetailsSlice = createSlice({
    name: 'get-publisher-details',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getSingleBankDetailsAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getSingleBankDetailsAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getSingleBankDetailsAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getSingleBankDetailsReducer = getSingleBankDetailsSlice.reducer